import { render, staticRenderFns } from "./QnaInfoView.vue?vue&type=template&id=04b7a1ea&scoped=true&"
import script from "./QnaInfoView.vue?vue&type=script&lang=js&"
export * from "./QnaInfoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b7a1ea",
  null
  
)

export default component.exports